import { createBrowserHistory } from 'history';

// Singleton history instance used across the app
export const history = createBrowserHistory({});

